import React from "react";
import { getPQRValue, getColumnClasses } from "./pqrDataUtils";
import { pqrStyles } from "./pqrStyles";

const PQRPreheatTable = ({ pdf }) => {
  const { colwidth, col1Class, col2Class, col3Class } = getColumnClasses(pdf,"preheat");

  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">PREHEAT(QW-406)</div>
      </div>
      <div style={pqrStyles.container}>
        <table id="table" className="PQRTable2" cellSpacing="0">
          <tbody>
            <tr className="PQRtrhide PQR_Toprt">
              <th className="PQRfillerMetalth PQR_noBotm" style={{ width: "27%" }}>
                Minimum preheat temperature <div className="PQRrcorner"> °C </div>
              </th>
              <td className={col1Class} style={{ width: colwidth }}>
                {getPQRValue(pdf[1]?.PQRD_Preheat_MinimumPreheatTemp)}
              </td>
              <td className={col2Class} style={{ width: colwidth }}>
                {getPQRValue(pdf[2]?.PQRD_Preheat_MinimumPreheatTemp)}
              </td>
              <td className={col3Class} style={{ width: colwidth }}>
                {getPQRValue(pdf[3]?.PQRD_Preheat_MinimumPreheatTemp)}
              </td>
            </tr>
            <tr className="PQRtrhide PQR_Botmrt">
              <th className="PQRfillerMetalth PQR_noTop"  style={{ width: "27%" }}>
                Maximum interpass temperature <div className="PQRrcorner"> °C </div>
              </th>
              <td className={col1Class} style={{ width: colwidth }}>
                {getPQRValue(pdf[1]?.PQRD_Preheat_MaximumInterpassTemp)}
              </td>
              <td className={col2Class} style={{ width: colwidth }}>
                {getPQRValue(pdf[2]?.PQRD_Preheat_MaximumInterpassTemp)}
              </td>
              <td className={col3Class} style={{ width: colwidth }}>
                {getPQRValue(pdf[3]?.PQRD_Preheat_MaximumInterpassTemp)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PQRPreheatTable;